<template>
    <div class="flex flex-col flex-grow px-6 py-6 bg-gray-50">
        <app-header>
            <h2 class="flex justify-start flex-1 text-2xl font-bold text-gray-800">Teams</h2>
        </app-header>
        <div class="flex h-24"></div>
        <content class="flex flex-col">
            <div class="flex flex-col justify-start flex-grow mb-4 bg-white rounded-lg shadow">
                <h3 class="flex items-center w-full h-12 px-6 text-lg font-semibold text-gray-800 border-b border-gray-200">Create a team</h3>
                <div class="flex items-start justify-start px-6 py-6">
                    <form ref="create" class="items-center w-full md:w-2/3">
                        <fieldset class="mb-3 form-group">
                            <label for="name" class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">Name</label>
                            <input
                                class="block w-full mt-1 transition duration-150 ease-in-out input form-textarea focus:border-gray-700 sm:text-sm sm:leading-5"
                                id="name"
                                type="text"
                                placeholder="Backend, UI, Sales..."
                                v-model="$v.name.$model"
                            />
                            <div v-if="$v.name.$error">
                                <p v-if="!$v.name.required" class="py-2 text-sm font-semibold text-red-500">
                                    A team name is required
                                </p>
                            </div>
                        </fieldset>
                        <fieldset class="mb-4 form-group">
                            <label class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2" for="name"
                                >Description <span class="text-sm text-gray-500">(Optional)</span></label
                            >
                            <input
                                class="block w-full mt-1 transition duration-150 ease-in-out input form-textarea focus:border-gray-700 sm:text-sm sm:leading-5"
                                id="description"
                                type="text"
                                placeholder=""
                                v-model="description"
                            />
                            <p class="text-sm text-gray-500 font-base">What's this team do?</p>
                        </fieldset>
                        <button
                            @click.prevent="cancel"
                            class="mr-4 text-gray-700 bg-gray-200 btn hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800"
                        >
                            Cancel
                        </button>
                        <button @click.prevent="create" type="button" class="text-white btn bg-primary-500 hover:bg-primary-400 focus:outline-none">Create team</button>
                    </form>
                </div>
            </div>
        </content>
    </div>
</template>

<script>
import AppHeader from '@/views/AppHeader';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'create-team',
    components: { AppHeader },
    metaInfo: {
        title: 'Create team',
    },
    data() {
        return {
            name: '',
            description: '',
        };
    },
    methods: {
        create() {
            if (!this.$v.$invalid) {
                this.$store
                    .dispatch('teams/create', {
                        team: {
                            name: this.name,
                            description: this.description,
                        },
                    })
                    .then(resp => {
                        this.$router.push({ name: 'team', params: { id: resp.data.id } });
                    });
            }
        },
        cancel() {
            this.name = '';
            this.description = '';
            this.$refs.create.reset();
        },
    },
    validations: {
        name: {
            required,
        },
    },
};
</script>
